import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icon/Icon'

function GuestBox({ boxClass = '', email, removeGuest }) {
  return (
    <div className={`user-box user-box--guest ${boxClass}`}>
      <div className="user-box__info">
        <span className="user-box__user">
          {email}
        </span>
      </div>
      <button
        type="button"
        onClick={() => removeGuest(email)}
        className="btn btn-transparent user-box__remove"
      >
        <Icon type={['far', 'times']} notSpaced />
      </button>
    </div>
  )
}

GuestBox.propTypes = {
  boxClass: PropTypes.string,
  email: PropTypes.string.isRequired,
  removeGuest: PropTypes.func.isRequired,
}

export default GuestBox
